import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesXinke {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        if (webcontext.Client.PageName == "Xinke") {

            if (webcontext.ConfigName == "TBCeShiXinKeLieBiaoXML" && webcontext.OpType.toLowerCase() == "query") {
                const a_ShouJiHaoMa = localStorage.getItem('searchVal');
                webcontext.RequestBody = JSON.stringify({ 'a_XinKeHaoMa': a_ShouJiHaoMa });
            }
        }
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext){
        // if (webParameterContext.Client.PageName == "TestXinkeForm") {
        //     if(webParameterContext.OpType =="add"){
        //         webContext.Status["url"]="/tabs/contact/ListForm/add/"+webContext.Status;
        //     }
        // }
        return webContext;
    }
}